import { Controller } from "@hotwired/stimulus"

/**
 * SearchableCheckboxesController
 *
 * Turns a long checkbox list into a searchable, scrollable picker: the search box
 * narrows the visible items and a live count reflects the current selection. No
 * dependency on a select library, and it degrades to a plain checkbox list without JS.
 *
 * Connects to data-controller="searchable-checkboxes"
 *   search  - the filter text input
 *   item    - each checkbox row (its data-name holds the lowercased label to match)
 *   count   - element whose text is set to the number of checked boxes
 *   empty   - message shown when the filter hides every item
 */
export default class extends Controller {
  static targets = ["search", "item", "count", "empty"]

  connect() {
    this.updateCount()
    this.filter()
  }

  filter() {
    const query = (this.hasSearchTarget ? this.searchTarget.value : "").trim().toLowerCase()
    let visible = 0

    this.itemTargets.forEach((item) => {
      const match = query === "" || (item.dataset.name || "").includes(query)
      // Bootstrap's .form-check sets display:block, which beats the [hidden] UA rule,
      // so toggle the d-none utility (display:none !important) instead.
      item.classList.toggle("d-none", !match)
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("d-none", visible !== 0)
  }

  updateCount() {
    if (!this.hasCountTarget) return

    const selected = this.itemTargets.filter((item) => {
      const box = item.querySelector('input[type="checkbox"]')
      return box && box.checked
    }).length

    this.countTarget.textContent = selected
  }

  // The filter box lives inside the catalog form; Enter must not submit the form.
  preventSubmit(event) {
    if (event.key === "Enter") event.preventDefault()
  }
}
